import { useQuery } from 'react-query'

import { getTicketDetails } from '../../endpoints/tickets'

export const useGetTicketDetails = (id: string | null) => {
    return useQuery(
        ['ticketDetails', id],
        async () => await getTicketDetails(id),
        {
            enabled: !!id
        }
    )
}